import React from 'react';
import { useParams } from 'react-router';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box } from '@material-ui/core';

import EmptyState from 'src/components/EmptyState';
import PerspectiveSelector from 'src/layouts/BasicLayout/TopBar/PerspectiveSelector';

import PerspectiveEditor from './Editors/PerspectiveEditor';
import usePerspective from './common/usePerspective';
import Toolbox from './Inspectors/Toolbox';
import Inspector from './Drawers/Inspector';
import StateTabs from '../../../../components/StateTabs';
import BaseDrawer from './Inspectors/BaseDrawer';

const ManagePerspective = () => {
  const { workflowId, perspectiveId } = useParams();

  return (
    <ManagePerspectiveContent
      key={perspectiveId}
      workflowId={workflowId}
      perspectiveId={perspectiveId}
    />
  );
};

interface Props {
  workflowId: string,
  perspectiveId: string,
}

const tabs = [
  {
    route: 'toolbox',
    label: 'Toolbox',
    component: Toolbox,
  },
  {
    route: 'inspector',
    label: 'Inspector',
    component: Inspector,
  },
];

const ManagePerspectiveContent = ({
  workflowId,
  perspectiveId,
}: Props) => {
  const [currentTabRoute, setCurrentTabRoute] = React.useState(tabs[0].route);
  const goToInspector = () => setCurrentTabRoute('inspector');

  const {
    onDragStart,
    onDragStop,
    onDrop,
    saveWidget,
    onResizeStop,
    deleteWidget,
    selectWidget,
    isDragging,
    setIsDragging,
    widgets,
    selectedWidget,
    getPerspective,
  } = usePerspective({
    workflowId,
    perspectiveId,
    onSelectWidget: goToInspector,
  });

  return (
    <>
      <Box position="relative" width="100%">
        {
          perspectiveId ? (
            <PerfectScrollbar options={{ suppressScrollX: true }}>
              <Box height="100%">
                <PerspectiveEditor
                  workflowId={workflowId}
                  widgets={widgets.filter((_widget) => _widget.perspectiveId.toString() === perspectiveId)} // todo - no to string after uuid
                  isDragging={isDragging}
                  onDragStart={onDragStart}
                  onDragStop={(x: any, y: any, z: any) => onDragStop(x, y, z)}
                  onDrop={onDrop}
                  onResizeStop={(x: any, y: any, z: any) => onResizeStop(x, y, z)}
                  selectWidget={selectWidget}
                  fullHeight
                  widgetProps={{
                    workflowId
                  }}
                  autoSize={false}
                />
              </Box>
            </PerfectScrollbar>
          ) : (
            <EmptyState
              width="100%"
              height="100%"
            >
              <PerspectiveSelector workflowId={workflowId} perspectiveId={perspectiveId} />
            </EmptyState>
          )
        }
      </Box>
      <BaseDrawer>
        <StateTabs
          currentTabRoute={currentTabRoute}
          setCurrentTabRoute={setCurrentTabRoute}
          tabs={tabs}
          componentProps={{
            // inspector
            selectedWidget,
            workflowId,
            saveWidget,
            deleteWidget,
            setCurrentTabRoute,

            // shared
            perspectiveId,
          }}
        />
      </BaseDrawer>
    </>
  );
};

export default ManagePerspective;
